import News from '../components/News';

function Prompt () {
    return (
        <div>
            <News />
        </div>
    )
}
export default Prompt;